import Vue from 'vue';
import DIALOG_TYPES from '../helpers/dialog-types';

export default {
  namespaced: true,

  state: {
    dialog: DIALOG_TYPES.DEFAULT,
  },

  mutations: {
    SET_DIALOG(state, payload) {
      Vue.set(state, 'dialog', payload);
    },

    CLOSE_DIALOG(state) {
      Vue.set(state, 'dialog', DIALOG_TYPES.DEFAULT);
    },
  },

  actions: {
    setDialog({ commit }, dialog) {
      commit('SET_DIALOG', dialog);
    },
  },
};
